/**
 * Reseller Assets editing API (HubSpot File Manager via /api/reseller-assets).
 * Every call throws with the server's message when the request fails.
 */

const BASE = '/api/reseller-assets';

function authHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem('authToken')}` };
}

async function send(path, options) {
  const response = await fetch(BASE + path, options);
  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.error || `Request failed (HTTP ${response.status})`);
  }
  return data;
}

function sendJson(method, path, body) {
  return send(path, {
    method,
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined
  });
}

function sendFile(method, path, file, fields) {
  const form = new FormData();
  form.append('file', file);
  Object.entries(fields || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined) form.append(key, value);
  });
  return send(path, { method, headers: authHeaders(), body: form });
}

export async function fetchCanEdit() {
  const data = await send('/me', { headers: authHeaders() });
  return data.canEdit === true;
}

export function uploadAsset(folderId, file) {
  return sendFile('POST', '/files', file, { folderId });
}

export function replaceAsset(fileId, file) {
  return sendFile('PUT', `/files/${encodeURIComponent(fileId)}/content`, file);
}

export function renameAsset(fileId, name) {
  return sendJson('PATCH', `/files/${encodeURIComponent(fileId)}`, { name });
}

export function deleteAsset(fileId) {
  return sendJson('DELETE', `/files/${encodeURIComponent(fileId)}`);
}

export function createAssetFolder(parentFolderId, name) {
  return sendJson('POST', '/folders', { parentFolderId, name });
}

export function deleteAssetFolder(folderId) {
  return sendJson('DELETE', `/folders/${encodeURIComponent(folderId)}`);
}

// Obsolete markers: { [fileId]: { at, by, note, replacedById, replacedByName } }
export async function fetchObsoleteAssets() {
  const data = await send('/obsolete', { headers: authHeaders() });
  return data.obsolete || {};
}

export function markAssetsObsolete(fileIds, { note, replacedById } = {}) {
  return sendJson('POST', '/obsolete', { fileIds, note, replacedById: replacedById || null });
}

export function makeAssetsCurrent(fileIds) {
  return sendJson('POST', '/obsolete/clear', { fileIds });
}
